import { TDictionary } from '../../../util/types'
import { SalesAgreement, SalesAgreementApiEntity, SalesAgreementProductLine } from './types'

export const mergeSaleLines = (data: SalesAgreementApiEntity[]) => {
  data.forEach((x) => {
    let temp: TDictionary<SalesAgreementProductLine> = {}
    x.lines.forEach((line) => {
      const lineKey = `${line.productVariantNumber}_${line.unitPrice}`
      if (!Object.keys(temp).includes(lineKey) || temp[lineKey].unitPrice !== line.unitPrice) {
        temp = {
          ...temp,
          [lineKey]: {
            ...line,
          },
        }
      } else {
        const amendedLine = temp[lineKey]
        amendedLine.quantity = {
          committed: amendedLine.quantity.committed + line.quantity.committed,
          delivered: amendedLine.quantity.delivered + line.quantity.delivered,
          invoiced: amendedLine.quantity.invoiced + line.quantity.invoiced,
          released: amendedLine.quantity.released + line.quantity.released,
          remaining: amendedLine.quantity.remaining + line.quantity.remaining,
        }

        temp[lineKey] = amendedLine
      }
    })

    x.lines = Object.keys(temp).map((key) => ({ ...temp[key] }))
  })

  return data
}

export const entityToSalesAgreement = (x: SalesAgreementApiEntity): SalesAgreement => {
  const totalFulfilled = x.lines.reduce(
    (partialSum, saleLine) => partialSum + saleLine.quantity.delivered,
    0,
  )
  const totalReleased = x.lines.reduce(
    (partialSum, saleLine) => partialSum + saleLine.quantity.released,
    0,
  )
  const totalCommitted = x.lines.reduce(
    (partialSum, saleLine) => partialSum + saleLine.quantity.committed,
    0,
  )

  const totalInvoiced = x.lines.reduce(
    (partialSum, saleLine) => partialSum + saleLine.quantity.invoiced,
    0,
  )

  const avgI: number[] = []
  x.lines.forEach((saleLine) => {
    avgI.push(
      (saleLine.quantity.committed - saleLine.quantity.remaining) / saleLine.quantity.committed,
    )
  }, 0)

  const i = Math.floor((avgI.reduce((pv, v) => pv + v, 0) / avgI.length) * 100)

  const percentageFulfilled = Math.ceil(i)

  return {
    ...x,
    totalFulfilled,
    totalReleased,
    totalCommitted,
    totalInvoiced,
    percentageFulfilled,
  }
}

export const transformSalesAgreements = (
  data: SalesAgreementApiEntity[],
): TDictionary<SalesAgreement> => {
  let dict: TDictionary<SalesAgreement> = {}
  data = mergeSaleLines(data)
  data.forEach((x) => {
    const agreement = entityToSalesAgreement(x)

    dict = {
      ...dict,
      [x.id]: agreement,
    }
  })

  return dict
}
